export default {
    getBatterySizeFromDerivative: function(derivative) {
        let size = 93 // This used to be hard coded so use as a fallback
        derivative.technicalItems.forEach((i) => {
            if (i.technicalItemName === 'BatteryCapacityInkWh') {
                size = i.technicalItemValue ? i.technicalItemValue : 0;
            }
        })
        return size;
    },

    getBatteryRangeFromDerivative: function(derivative) {
        let range = 296 // This used to be hard coded so use as a fallback
        derivative.technicalItems.forEach((i, idx ) => {
            if (i.technicalItemName === 'NEDCMaximumEVRangeMiles') {
                range = i.technicalItemValue ? parseInt(i.technicalItemValue.replace(' miles', '')) : 0;
            }
        })
        return range;
    },

    milesPerKWh(wLTPRangeMiles, batterySizeKwh) {
        return Number(wLTPRangeMiles / batterySizeKwh).toFixed(2);
    },

    averagePencePerMile(totalMonthlyCost, milesPerCalendarMonth) {
        return Number(totalMonthlyCost / milesPerCalendarMonth).toFixed(2);
    },
}
